import { useEffect, useState } from "react";
import styles from "../MoveOutChecklist.module.css";
import dayjs from "dayjs";

const Header = ({ leaseData, propertyDetails }) => {
    const [leaseStartDate, setLeaseStartDate] = useState(null);

    useEffect(() => {
        if (leaseData?.archived_leases?.length > 0) {
            setLeaseStartDate(leaseData?.archived_leases[0]?.start_date);
        } else {
            setLeaseStartDate(leaseData?.start_date);
        }
    }, [leaseData]);

    return (<>
        <p className={`${styles.MoveOutIntroText}`}>This Move-Out Condition Report is part of the Lease Agreement dated <span>{dayjs(leaseStartDate).format('MM/DD/YYYY')}</span> between <span>{leaseData?.tenant_names}</span> (Tenant) and <span>{propertyDetails?.owner_name}</span> (Landlord) for the property located at <span>{propertyDetails?.full_address}</span>.</p>
        <p className={`${styles.MoveOutIntroText}`}>The Landlord/Manager and Tenant have each inspected the property listed above. Tenant understands that this Condition Report is a part of their Lease Agreement and will be used to document the condition of the dwelling upon gaining occupancy and upon vacating.</p>
        <div className={`${styles.MoveOutIntronotice}`}>YOU SHOULD COMPLETE THIS CHECKLIST, NOTING THE CONDITION OF THE RENTAL PROPERTY, AND RETURN IT TO THE LANDLORD WITHIN 7 DAYS AFTER OBTAINING POSSESSION OF THE RENTAL UNIT. YOU ARE ALSO ENTITLED TO REQUEST AND RECEIVE A COPY OF THE LAST TERMINATION INVENTORY CHECKLIST WHICH SHOWS WHAT CLAIMS WERE CHARGEABLE TO THE LAST PRIOR TENANTS.</div>
    </>);
};

export default Header;
